import React from "react";
import PropTypes from "prop-types";
import { useFinaidYear } from "components/hooks/useFinaidYear";
import { SectionTitle } from "./SectionTitle";
import { ItemDetails } from "./ItemDetails";
import { SectionSummary } from "./SectionSummary";
import { SectionAccordion } from "./SectionAccordion";

export function SectionByType({ type, color, showDecimals }) {
  const { sectionInfo, messageEstDisbursements } = useFinaidYear(
    ({
      finaidAwards: {
        awards: { [type]: sectionInfo } = {},
        messages: { messageEstDisbursements } = {},
      },
    }) => ({ sectionInfo, messageEstDisbursements })
  );

  if (sectionInfo) {
    const {
      total: { title, amount: total } = {},
      links = [],
      items = [],
    } = sectionInfo;

    return (
      <div>
        <SectionTitle title={title} links={links} />
        <SectionAccordion collapsible multiple color={color}>
          {items.map((item, index) => (
            <ItemDetails
              key={index}
              item={item}
              messageEstDisbursements={messageEstDisbursements}
              showDecimals={showDecimals}
            />
          ))}
        </SectionAccordion>
        <SectionSummary
          title={title}
          total={total}
          showDecimals={showDecimals}
        />
      </div>
    );
  }

  return null;
}

SectionByType.displayName = "SectionByType";
SectionByType.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
  showDecimals: PropTypes.bool,
};
